/**
 * ****************************************************************************
 * @description     :   Reducer to receive action and change state for holon
 * @created at      :   2023/07/25
 * @created by      :   SonMBG - sonmbg@toploop.co
 * @package         :   dashlite-admin-react
 * @copyright       :   Copyright (c) TOPLOOP
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * import libraries
 */
import Actions from './action';


/**
 * Initial state of app
 */
const initialState = {
    user: {},
    user_id: "",
    hex_id: "",
    avatar_user: "",
    full_name_user: "",
    status_user: "0",
    positions: [],
    loading: {
        loadingAccount: false,
        loadingUpdateAccount: false,
        loadingPositions: false,
    },
    updateUserError: {},
    inquiryFormValue: null,
    loginError: {},
    forgotIdPasswordError: {},
    saleList: {
        records: [],
        limit: 0,
        page: 1,
        total: 0,
        totalPage: 1,
    },
    managerList: {
        records: [],
        limit: 0,
        page: 1,
        total: 0,
        totalPage: 1,
    },
};

/**
 * Reducer to process change data of app
 * -----------------------------------------
 * @author : QuyPN - 2023/07/18 - create
 * @param  : {Object} state - Current sate of app
 * @param  : {Object} action - information of action will process
 * @access : public
 */
export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case Actions.GET_ACCOUNT:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    loadingAccount: true,
                },
            }
        case Actions.GET_ACCOUNT_SUCCESS:
            return {
                ...state,
                user: action?.payload?.user,
                user_id: action?.payload?.user_id,
                hex_id: action?.payload?.hex_id,
                status_user: action?.payload?.status_user,
                avatar_user: action?.payload?.avatar_user,
                full_name_user: action?.payload?.full_name_user,
                loading: {
                    ...state.loading,
                    loadingAccount: false,
                },
            }
        case Actions.GET_ACCOUNT_FAILURE:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    loadingAccount: false,
                },
            }
        case Actions.UPDATE_ACCOUNT:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    loadingUpdateAccount: true,
                },
            }
        case Actions.UPDATE_ACCOUNT_SUCCESS:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    loadingUpdateAccount: false,
                },
            }
        case Actions.UPDATE_ACCOUNT_FAILURE:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    loadingUpdateAccount: false,
                },
                updateUserError: action?.payload,
            }
        case Actions.UPDATE_ALARM_ACCOUNT:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    loadingUpdateAccount: true,
                },
            }
        case Actions.UPDATE_ALARM_ACCOUNT_SUCCESS:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    loadingUpdateAccount: false,
                },
            }
        case Actions.UPDATE_ALARM_ACCOUNT_FAILURE:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    loadingUpdateAccount: false,
                },
                updateUserError: action?.payload,
            }
        case Actions.CLEAR_UPDATE_ACCOUNT_ERROR:
            return {
                ...state,
                updateUserError: {},
            }
        case Actions.SAVE_INQUIRY_DATA:
            return {
                ...state,
                inquiryFormValue: action.payload.inquiryFormValue
            };
        case Actions.REMOVE_INQUIRY_DATA:
            return {
                ...state,
                inquiryFormValue: null
            };
        case Actions.LOGIN_FAILURE:
            return {
                ...state,
                loginError: action?.payload,
            }
        case Actions.CLEAR_LOGIN_ERROR:
            return {
                ...state,
                loginError: {},
            }
        case Actions.LOGOUT:
            return {
                ...state,
            }
        case Actions.LOGOUT_SUCCESS:
            return {}
        case Actions.FORGOT_ID_PASSWORD_FAILURE:
            return {
                ...state,
                forgotIdPasswordError: action?.payload,
            }
        case Actions.CLEAR_FORGOT_ID_PASSWORD_ERROR:
            return {
                ...state,
                forgotIdPasswordError: {},
            }
        //
        case Actions.GET_SALE_LIST:
            return {
                ...state
            }
        case Actions.GET_SALE_LIST_SUCCESS:
            return {
                ...state,
                saleList: action.payload
            }
        case Actions.GET_SALE_LIST_FAILURE:
            return {
                ...state,
                saleList: []
            }
        //
        case Actions.GET_MANAGER_LIST:
            return {
                ...state
            }
        case Actions.GET_MANAGER_LIST_SUCCESS:
            return {
                ...state,
                managerList: action.payload
            }
        case Actions.GET_MANAGER_LIST_FAILURE:
            return {
                ...state,
                managerList: []
            }
        case Actions.GET_POSITIONS_OF_BUSINESS_CUSTOMER:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    loadingPositions: true,
                },
            }
        case Actions.GET_POSITIONS_OF_BUSINESS_CUSTOMER_SUCCESS:
            return {
                ...state,
                positions: action.payload,
                loading: {
                    ...state.loading,
                    loadingPositions: false,
                },
            }
        case Actions.GET_POSITIONS_OF_BUSINESS_CUSTOMER_FAILURE:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    loadingPositions: false,
                },
            }
        default:
            return state;
    }
}
